import Layout from "../../components/Layout";
import { useUserState } from "../../context/UserContext";
import StudentExam from "./student/studentexam";

const index = () => {
  const { userRole } = useUserState();
  // eslint-disable-next-line no-console
  console.log("come", userRole?.role);

  return (
    <Layout children={
      <>
        <StudentExam />
      </>
    }
    />
  );
};

export default index;
